import { MDBDatatable, MDBIcon, MDBInputGroup, MDBAlert, MDBModalFooter, MDBBtn, MDBToast } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";

import { useLocation } from "react-router";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import Popup from "../components/Popup";
import CreateStaff from "../components/createStaff";
import { checkStaff, deleteStaff, getCheckStaff, logEvent, saveImportStaff, getGymCoordinates, getPricingPlansById } from "../services/apiServices";
import deleteImg from "./../components/images/delete.svg";
import editImg from "./../components/images/edit.svg";
import SattendanceList from "./SattendanceList";
import PageError from "./PageError";
import ImportExcelModal from "../components/ImportExcelModal";
import ExcelJS from 'exceljs';
import { useAnalytics } from "../hooks/useAnalytics";
import { useAccess } from "../context/AccessContext";

const Staff = () => {
  const { trackButtonClick } = useAnalytics();
  const [userData, setData] = useState([]);
  const [openDetailsPop, setOpenDetailsPop] = useState(false);
  const [selData, setSelData] = useState(false);
  const [checkedStaff, setCheckedStaff] = useState([]);
  const [Error2, setError2] = useState("")
  const [addandSave, setaddandSave] = useState(1);
  const [sId, setSId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const [inputText, setInputText] = useState("");
  const [apiError, setApiError] = useState(false);
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState("");
  const [Alerttxt, setAlerttxt] = useState("");
  const [importedData, setImportedData] = useState([]);
  const [importError, setImportError] = useState("");
  const [importPopUp, setImportPopUp] = useState(false);
  const { handlePageAccess, rolename } = useAccess();
  const roleAccess = handlePageAccess("staff")


  const toggleModal = () => {
    setImportPopUp(true);
    console.log("pop up trigred")

  }
  const popUpClose = () => {
    setImportPopUp(false);
    setErrorMessage("");

  }
  const handleStaffDownload = () => {
    const sampleData = [
      {
        ID: "1",
        firstname: "Harsha",
        lastname: "K",
        number: "+917485961231",
        email: "Harsha@gmail.com",
        username: "Harsha@gmail.com",
        password: "12345678",
        role: "Staff",
        age: "30",
        gender: "Male",

      },
      {
        ID: "2",
        firstname: "Harshita",
        lastname: "V",
        number: "+917485966311",
        email: "Harshita@gmail.com",
        username: "Harshita@gmail.com",
        password: "987654321",
        role: "Staff",
        age: "25",
        gender: "Female",

      },
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sample Data");
    worksheet.columns = [
      { header: "Employee ID", key: "ID", width: 10 },
      { header: "First Name", key: "firstname", width: 15 },
      { header: "Last Name", key: "lastname", width: 15 },
      { header: "Username", key: "username", width: 20 },
      { header: "Email", key: "email", width: 25 },
      { header: "Phone Number", key: "number", width: 20 },
      { header: "Password", key: "password", width: 30 },
      { header: "Role", key: "role", width: 10 },
      { header: "Age", key: "age", width: 10 },
      { header: "Gender", key: "gender", width: 10 },

    ];

    sampleData.forEach((data) => {
      worksheet.addRow(data);
    });


    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Sample_Staff_Data.xlsx";
      link.click();
    });
  };


  const importStaffSheet = async (file) => {

    if (!file) {
      console.error("No file selected");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.onload = async () => {
      const buffer = reader.result;
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.getWorksheet(1);

      const importedData = [];
      const validationErrors = [];

      const headers = {};
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        headers[cell.value] = colNumber;
      });




      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {

          let phoneNumber = headers["Phone Number"]
            ? row.getCell(headers["Phone Number"])?.value || ""
            : "";

          const formattedPhone = formattedPhoneFunction(phoneNumber);

          const capitalizeFirstLetter = (str) => {
            if (!str) return "";
            str = str.toString().trim().toLowerCase();
            return str.charAt(0).toUpperCase() + str.slice(1);
          };

          const extractPlainValue = (value) => {
            if (!value) return "";
            if (typeof value === "object") {
              if (value.text) return value.text.toString().trim().toLowerCase();
              if (value.richText) {
                return value.richText.map(rt => rt.text).join("").trim().toLowerCase();
              }
              return JSON.stringify(value).trim().toLowerCase();
            }
            return value.toString().trim().toLowerCase();
          };

          const transformedRow = {
            ID: row.getCell(headers['Employee ID']).value || "",
            firstname: capitalizeFirstLetter(row.getCell(headers['First Name']).value),
            lastname: capitalizeFirstLetter(row.getCell(headers['Last Name']).value),
            username: extractPlainValue(row.getCell(headers['Username']).value || ""),
            // username: row.getCell(headers['Username']).value || "",
            email: extractPlainValue(row.getCell(headers['Email']).value || ""),
            number: formattedPhone,
            password: row.getCell(headers['Password']).value || "",
            role: (row.getCell(headers['Role']).value).toLowerCase(),
            age: row.getCell(headers['Age']).value || "",
            gender: capitalizeFirstLetter(row.getCell(headers['Gender']).value),

          };

          const errors = validateRow(transformedRow, rowNumber);
          if (errors.length > 0) {
            validationErrors.push(...errors);
          } else {
            importedData.push(transformedRow);
          }
        }

      });


      // setImportedData(importedData);



      console.log("Imported Data:", importedData);
      let requestData = {
        gymId: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",

      };
      if (validationErrors.length > 0) {
        console.error("Validation Errors:", validationErrors);
        requestData.status = "failed";
        requestData.errors = validationErrors;


        setErrorMessage(validationErrors.join("\n"));
        setTimeout(() => {
          setImportPopUp(false);
          setErrorMessage("");
        }, 20000);
        // await saveImportStaff(requestData);

        return;
      }

      if (importedData.length === 0) {
        setImportError("The file is empty or does not contain valid Staff data.");
        setImportPopUp(false);
        return;
      } else {
        setImportError("");
      }
      try {

        console.log("Data for Backend:", importedData);


        requestData.status = "success";
        requestData.data = importedData;
        if (plansInfo != null && plansInfo?.limitation && plansInfo?.limitation?.stafflogin != -1) {
          let importtedstaff = importedData.filter((obj) => obj.role == "staff");
          let userDataStaff = userData.filter((obj) => (obj.role).toLowerCase() == "staff");

          if ((userDataStaff.length + importtedstaff.length) > plansInfo?.limitation?.stafflogin) {
            setError2("Your imported data exceeds the allowed limit. Please upgrade your plan for higher capacity.");
            return;
          }
        }
        if (plansInfo != null && plansInfo?.limitation && plansInfo?.limitation?.adminlogin != -1) {
          let userDataAdmin = userData.filter((obj) => (obj.role).toLowerCase() == "admin");
          let importtedAdmin = importedData.filter((obj) => obj.role == "admin");

          if ((userDataAdmin.length + importtedAdmin.length) > plansInfo?.limitation?.adminlogin) {
            setError2("Your imported data exceeds the allowed limit. Please upgrade your plan for higher capacity.");
            return;
          }
        }
        if (localStorage.getItem("loggedUserInfo")) {
          const response = await saveImportStaff(
            requestData,
            localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
          console.log(response);
          if (!response) {
            return;
          }
          if (response === "false") {
            setApiError(true)
          } else {
            const result = await response.json();
            console.log("Backend Response:", result);
            if (result.message == "Success") {
              setAlerttxt("Staff(s) Imported Successfully!");
              getPricingPlansBYGymid();
            }
            else {
              setError2("Failed to Import Staff(s)");
            }

            setImportPopUp(false);

          }

        }


      } catch (error) {
        console.error("Error during import:", error.message);

      }
    };

    reader.readAsArrayBuffer(file);
  };
  const getPricingPlansBYGymid = async () => {
    const response = await getPricingPlansById(JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid);
    if (!response || response === "false") {
      return
    }
    const recinfo = await response.json();
    if (recinfo && recinfo.feature) {
      localStorage.setItem("planInfo", JSON.stringify(recinfo));
    }
  }
  const formattedPhoneFunction = (phone) => {
    if (!phone) return null;
    phone = phone.toString().trim();
    const onlyDigits = phone.replace(/[^\d+]/g, "");
    if (onlyDigits.startsWith("+")) {
      return onlyDigits;
    }
    if (onlyDigits.length === 10) {
      return "+91" + onlyDigits;
    }
    if (onlyDigits.length === 12 && onlyDigits.startsWith("91")) {
      return "+" + onlyDigits;
    }
    return null;
  };



  const validateRow = (row, rowNumber) => {
    const errors = [];

    if (!row.ID) errors.push(`Row ${rowNumber}: Employee ID is required.`);
    if (!row.firstname) errors.push(`Row ${rowNumber}: First Name is required.`);
    if (!row.lastname) errors.push(`Row ${rowNumber}: Last Name is required.`);
    if (!row.username) errors.push(`Row ${rowNumber}: Username is required.`);
    if (!row.email) errors.push(`Row ${rowNumber}: Email is required.`);
    if (!row.number) errors.push(`Row ${rowNumber}: Phone Number is required.`);
    if (!row.password) errors.push(`Row ${rowNumber}: Password is required.`);
    if (!row.role) errors.push(`Row ${rowNumber}: Role is required.`);

    const formatPhone = (phone) => {
      let formatted = null;

      try {
        if (phone.startsWith('+')) {
          formatted = phone.replace('+', '');

        } else if (phone.startsWith('1')) {

          formatted = phone;
        } else if (phone.length < 10) {

          formatted = null;
        } else if (phone.length === 12) {

          formatted = phone;
        } else if (phone.length === 10) {

          formatted = '+91' + phone;
        }

        else {

          formatted = phone;
        }
      } finally {

        return formatted;
      }
    };



    const formattedPhone = formatPhone(row.number);
    if (!formattedPhone) {
      errors.push(`Row ${rowNumber}: Invalid phone number format(including country code).`);
    } else if (!/^\d{12}$/.test(formattedPhone)) {
      errors.push(`Row ${rowNumber}: Phone number must be exactly 12 digits (including country code).`);
    }


    if (row.email && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(row.email)) {
      errors.push(`Row ${rowNumber}: Invalid Email format.`);
    }

    if (row.username && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(row.username)) {
      errors.push(`Row ${rowNumber}: Invalid Email format for username.`);
    }

    if (row.password && row.password.length < 6) {
      errors.push(`Row ${rowNumber}: Password must be at least 6 characters long.`);
    }


    if (row.age && (isNaN(row.age) || row.age <= 0)) {
      errors.push(`Row ${rowNumber}: Age must be a positive number.`);
    }


    if (row.gender) {
      const normalizedGender = row.gender.trim().toLowerCase();
      if (!["male", "female"].includes(normalizedGender)) {
        errors.push(`Row ${rowNumber}: Gender must be either 'Male' or 'Female'.`);
      } else {
        row.gender = normalizedGender.charAt(0).toUpperCase() + normalizedGender.slice(1);
      }
    }
    return errors;
  };


  const [gymCoordinates, setgymCoordinates] = useState(null);
  const [userLocation, setUserLocation] = useState(null);


  function isMobileDevice() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }



  const getCurrentLocation = () => {

    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by this browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;


        setUserLocation({ lat: latitude, lng: longitude });
      },
      (error) => {
        console.error("Error getting location:", error.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };


  const fetchCoordinates = async () => {
    const bid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid || "";

    if (!bid) {
      console.error("Gym ID is missing");
      return;
    }

    try {
      const data = await getGymCoordinates(bid);
      const response = await data.json();
      setgymCoordinates(response.gymlocation);
    } catch (error) {
      console.error("Error fetching coordinates", error);
    }
  };

  useEffect(() => {
    if (isMobileDevice()) {

      fetchCoordinates();
      getCurrentLocation()
    }
  }, [])




  const handleReload = () => {
    window.location.reload();
  }

  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  function onbacktoStaff(flag) {
    setAlerttxt(flag)
    setTimeout(() => {
      fetchData();
    }, 1000);
  }





  const errorLimit = () => {
    setError2("You have reached the maximum limit of staff members for this plan. Please upgrade your plan to add more staff members.");
  };

  function openAddform(e) {
    setSId(0);
    setaddandSave(1);
    togglePopup();
  }
  async function deleteStaffs(tobject) {
    console.log(tobject);
    if (window.confirm("Are you sure want to delete this Staff Member?")) {
      await deleteStaff(tobject._id);
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let flag = `Staff Deleted Successfull (${tobject.firstname} ${tobject.lastname})`;
      let Eventtype = "staff";
      let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
      await trackButtonClick("Staff", "Delete_Staff", "staff", {});
      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
      setAlerttxt("Staff Deleted Successfully!");

      setTimeout(() => {
        fetchData();
      }, 1000)
      // window.location.reload(true);
    }
    return
  }

  function openDetails(obj, data) {
    setSelData(data);
    setSId(obj.id);
    setOpenDetailsPop(true);
  }
  function closeDetails(id) {
    setSId(0);
    setOpenDetailsPop(false);
  }
  function openEditStaff(tId) {
    setSId(tId.id);
    togglePopup();
  }

  function checkandUpdate(staff) {
    if (staff.attendance.length > 0) {
      if (staff.attendance[0].intime && !staff.attendance[0].outtime) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }



  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c * 1000;
    return distance;
  }


  async function checkinUser(e, obj, checked) {
    let sId = obj._id;
    e.preventDefault();
    checked = checkedStaff.filter((item) => item === sId);
    let chekinflag = checked.length === 0 ? "1" : "0";
    let gymid = localStorage.getItem("loggedUserInfo")
      ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      : "";
    if (isMobileDevice() && gymCoordinates &&
      (obj?.rolevalues ? !obj.rolevalues.includes(1) : obj?.role === "staff")) {
      try {


        const distance = calculateDistance(
          userLocation.lat,
          userLocation.lng,
          gymCoordinates.lat,
          gymCoordinates.lng
        );

        const maxDistance = gymCoordinates?.maxdistance;
        if (distance > maxDistance) {
          if (chekinflag === "0") {
            setError2("Check-out failed. You are not within the allowed check-in zone");
          } else if (chekinflag === "1") {
            setError2("Check-in failed. You are not within the allowed check-in zone");
          } else {
            setError2("Invalid check-in state detected.");
          }
          return;
        }

        await proceedCheckin(sId, chekinflag, gymid, obj);
      } catch (error) {
        console.error("Error during location check:", error);
        setError2("Error retrieving location.");
      }
    } else {

      await proceedCheckin(sId, chekinflag, gymid, obj);
    }
  }


  async function proceedCheckin(sId, chekinflag, gymid, obj) {
    const updates = {
      checkFlag: chekinflag,
      sid: sId,
      date: new Date(),
      gymid: gymid,
    };
    let saverep = await checkStaff(updates, sId);
    if (!saverep) {
      return;
    }
    if (saverep === "false") {
      setApiError(true)
      return;
    }

    await saverep.json();

    if (chekinflag === "1") {
      setCheckedStaff([...checkedStaff, sId]);
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let flag = `Staff Check-In Successful (${obj.firstname} ${obj.lastname})`;
      let Eventtype = "check-In/Out";
      let username1 = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).email
        : "";

      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
      await trackButtonClick("Staff", "Staff_Check-in", "staff", {});
    } else {
      const nusers = checkedStaff.filter((item) => item !== sId);
      setCheckedStaff(nusers);
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let flag = `Staff Check-Out Successful (${obj.firstname} ${obj.lastname})`;
      let Eventtype = "check-In/Out";
      let username1 = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).email
        : "";

      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
      await trackButtonClick("Staff", "Staff_Check-in", "staff", {});

    }

    localStorage.setItem("setting_save_staff", "Profile saved successfully");
    setData((prevState) => {
      if (prevState.length > 0) {
        const updatedData = prevState.map((entry) => {
          if (entry._id === sId) {
            if (chekinflag === "1") {
              let values = {
                bId: localStorage.getItem("loggedUserInfo")
                  ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                  : "",
                createdAt: new Date(),
                updatedAt: new Date(),
                date: new Date(),
                id: sId,
                intime: new Date(),
                member_type: "2",
                _id: sId,
              };
              entry.attendance.unshift(values);
            } else {
              entry.attendance[0].outtime = new Date();
            }
          }
          return entry;
        });
        return updatedData;
      }
      return prevState;
    });
  }

  async function fetchData() {
    if (localStorage.getItem("loggedUserInfo")) {
      const response = await getCheckStaff(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      } else {

        const usersData = await response.json();
        console.log(usersData);
        if (!usersData) {
          return;
        }

        let loggedusers = [];
        let notloggedusers = [];
        let mloggedusers = [];
        let mnotloggedusers = [];
        for (let staff of usersData) {
          if (checkandUpdate(staff)) {
            loggedusers = [...loggedusers, staff._id];
          } else {
            notloggedusers = [...notloggedusers, staff._id];
          }
          const currentTime = new Date();
          const startOfToday = new Date(currentTime);
          startOfToday.setHours(0, 0, 0, 0);
          const endOfToday = new Date(currentTime);
          endOfToday.setHours(23, 59, 59, 999);

          let checkinStaff = staff.attendance.length > 0 ?
            staff.attendance.filter(obj => {
              const intime = new Date(obj.intime);
              return intime >= startOfToday && intime <= endOfToday;
            }) : [];

          if (checkinStaff.length > 0) {
            mloggedusers = [...mloggedusers, staff];
          } else {
            mnotloggedusers = [...mnotloggedusers, staff];
          }
        }
        if (location && location.state && location.state.data !== 2) {
          setData(mloggedusers);
        } else if (location && location.state && location.state.data === 2) {
          setData(mnotloggedusers);
        } else {
          setData(usersData);
        }
        setCheckedStaff(loggedusers);
      }
    }
  }
  useEffect(() => {
    fetchData();
    // fetchGymInfo();
  }, [location, importPopUp]);
  const selectedUserIndex = JSON.parse(localStorage.getItem("loggedUserInfo"))
    ? (userData.findIndex((user) => user._id === JSON.parse(localStorage.getItem("loggedUserInfo"))._id)) : 1;
  if (selectedUserIndex !== -1) {
    const selectedUser = userData.splice(selectedUserIndex, 1)[0];
    userData.unshift(selectedUser);
  }
  const usersData = (userData.length > 0 && userData[0] !== undefined) ? userData.filter((el) => {
    if (inputText.trim() === "") {
      return userData;
    } else {
      const trimmedInput = inputText.trim().toLowerCase();
      const fullName = `${el.firstname || ''} ${el.lastname || ''}`.toLowerCase();

      return (
        (el.firstname && el.firstname.toLowerCase().includes(trimmedInput)) ||
        (el.lastname && el.lastname.toLowerCase().includes(trimmedInput)) ||
        (el.number && el.number.toLowerCase().includes(trimmedInput)) ||
        (el.email && el.email.toLowerCase().includes(trimmedInput)) ||
        fullName.includes(trimmedInput)
      );
    }
  }) : [];
  const roleOptions = [
    { value: 1, label: 'Owner' },
    { value: 2, label: 'Manager' },
    { value: 3, label: 'Trainer' },
    { value: 4, label: 'FrontDesk' },
    { value: 5, label: 'Accountant' },
    { value: 6, label: 'CampaignManager' }
  ];

  console.log(checkedStaff);
  let tmrow = [];
  if (roleAccess?.editstaff !== 1) {
    usersData.forEach((data, index) => {
      let rarray = [];
      rarray.push(index + 1);
      rarray.push(data.firstname + " " + data.lastname);
      rarray.push(data.number);
      rarray.push(data.email);
      rarray.push(<label className="title">
        {data?.rolevalues?.length > 0
          ? roleOptions?.length > 0
            ? (() => {
              const filteredRoles = roleOptions.filter(option =>
                data.rolevalues.includes(option.value)
              );
              return filteredRoles
                .map(option => option.label)
                .join(', ');
            })()
            : "--"
          : data.role == "admin" ? "Owner" : "Trainer" || "--"
        }

      </label>);
      rarray.push(index === 0 ?
        <button
          type="button"
          className={
            checkedStaff.filter((item) => item === data._id).length > 0
              ? "btn btn-danger  w-120"
              : "btn btn-primary  w-120"
          }
          onClick={(e) => checkinUser(e, data, checkedStaff.filter((item) => item === data._id))}
        >
          {checkedStaff.filter((item) => item === data._id).length > 0
            ? "Check-Out"
            : "Check-In"}
        </button>
        :
        <button
          type="button"
          className={checkedStaff.filter((item) => item === data._id).length > 0
            ? "btn btn-danger  w-120" : "btn btn-primary  w-120"}
        >
          {checkedStaff.filter((item) => item === data._id).length > 0
            ? "Check-Out"
            : "Check-In"}
        </button>

      );
      rarray.push(index === 0 ?
        <>
          <button
            type="button"
            className="button-link ml10" style={{ margin: "17px" }}>
            <img
              src={editImg}
              width="20px"
              alt="Edit"
              onClick={(e) => openEditStaff({ id: data._id })}
            />
          </button>
          <button
            type="button"
            className="button-link ml20">
            <img
              src={deleteImg}
              width="15px"
              alt="Delete"
              onClick={(e) => deleteStaffs(data)}
            />
          </button>
        </>
        :
        <>
          <button
            type="button"
            className="button-link ml10" style={{ margin: "17px" }}>
            <img
              src={editImg}
              width="15px"
              alt="Edit"
            />
          </button>
          <button
            type="button"
            className="button-link ml20">
            <img
              src={deleteImg}
              width="15px"
              alt="Delete"
            />
          </button>
        </>
      );
      rarray.push(index === 0 ?
        <button
          type="button"
          className="button-link link-color" onClick={(e) => openDetails({ id: data._id }, data)}>
          View Attendance
        </button>
        :
        <button
          type="button"
          className="button-link">
          View Attendance
        </button>
      );

      tmrow.push(rarray);
    });
  }
  else {
    usersData.forEach((data, index) => {
      let rarray = [];
      rarray.push(index + 1);
      rarray.push(data.firstname + " " + data.lastname);
      rarray.push(data.number);
      rarray.push(data.email);

      // rarray.push(
      //   <label className="title">
      //     {data?.rolevalues?.length > 0
      //       ? roleOptions?.length > 0
      //         ? roleOptions
      //           .filter(option => data.rolevalues.includes(option.value))
      //           .map(option => option.label)
      //           .join(', ')
      //         : "--"
      //       : data.role || "--"
      //     }
      //   </label>
      // );
      rarray.push(
        <label className="title">
          {data?.rolevalues?.length > 0
            ? roleOptions?.length > 0
              ? (() => {
                const filteredRoles = roleOptions.filter(option =>
                  data.rolevalues.includes(option.value)
                );
                console.log("Filtered roles:", filteredRoles); // Debug log
                return filteredRoles
                  .map(option => option.label)
                  .join(', ');
              })()
              : "--"
            : data.role == "admin" ? "Owner" : "Trainer" || "--"
          }

        </label>
      );
      rarray.push(roleAccess?.editstaff === 1 ? data?.enablefence ? "Enabled" : "Disabled" : "--");
      rarray.push(
        <button
          type="button"
          className={checkedStaff.filter((item) => item === data._id).length > 0 ? "btn btn-danger  w-120" : "btn btn-primary  w-120"}
          onClick={(e) =>
            checkinUser(
              e,
              data,
              checkedStaff.filter((item) => item === data._id)
            )
          }
        >
          {checkedStaff.filter((item) => item === data._id).length > 0
            ? "Check-Out"
            : "Check-In"}
        </button>
      );
      rarray.push(
        <>
          <button
            type="button"
            className="button-link ml10" style={{ margin: "17px" }}>
            <img
              src={editImg}
              width="15px"
              alt="Edit"
              onClick={(e) => openEditStaff({ id: data._id })}
            />
          </button>
          {(roleAccess?.editstaff == 1) && <button
            type="button"
            className="button-link ml20">
            <img
              src={deleteImg}
              width="15px"
              alt="Delete"
              onClick={(e) => deleteStaffs(data)}
            />
          </button>}
        </>
      );
      rarray.push(
        <button
          type="button"
          className="button-link link-color" onClick={(e) => openDetails({ id: data._id }, data)}>
          View Attendance

        </button>
      );

      tmrow.push(rarray);
    });
  }
  let arr = ["S.no", "Name", "Contact", "Email", "Role", "Geo-Fencing", "Check-In/Check-Outs", "Action", "Attendance"]


  if (roleAccess?.editstaff !== 1) {
    arr = ["S.no", "Name", "Contact", "Email", "Role", "Check-In/Check-Outs", "Action", "Attendance"]
  }


  const basicData = {
    columns: arr,
    rows: tmrow,
  };
  const plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
  let flagValue = true;
  if (plansInfo != null && !plansInfo.feature.stafflogin) {
    flagValue = false;
  }
  // if (plansInfo != null && usersData.length > 0 && plansInfo.planLimitation.stafflogin != -1) {
  //   let limit = plansInfo.planLimitation.stafflogin;
  //   let staffCount = 0;
  //   staffCount = usersData.length > 0 ? (usersData.filter((obj) => obj.role == 'staff') ? (usersData.filter((obj) => obj.role == 'staff')?.length) : 0) : [];

  //   if (limit <= staffCount) {
  //     flagValue = false;
  //   }
  // }

  return (
    <>
      <LeftPane isactive="6" />
      <Header />
      {apiError ? <PageError handleReload={handleReload} /> :
        <div className="gym-main gym-main-div">
          <div className="gym-container " id="showcase">
            <div className="createplanmain w-100">
              <h3 className="gym-large">Staff Manager</h3>
              {flagValue && <>
                {roleAccess?.editstaff == 1 &&
                  <button
                    type="button"
                    className="button-link link-color p-1 mb-2" id="adduserBtn" onClick={(e) => openAddform(e)} >
                    <div className="createplan">
                      <span className="addic">
                        <MDBIcon fas icon="plus" />
                      </span>
                      <span className="pl-5">Add Staff</span>
                    </div>
                  </button>
                }
              </>}
            </div>
            <div className="d-flex align-items-center mb-3">

              <MDBInputGroup
                textAfter={<MDBIcon fas icon="search" />}
              >
                <input
                  className="form-control gym-input forminput"
                  type="text"
                  placeholder="search by member"
                  onChange={(event) => inputHandler(event)}
                />
              </MDBInputGroup>
              {(localStorage.getItem("loggedUserInfo")) && roleAccess?.editstaff == 1 &&
                <button type="submit" className="ms-2 btnheight btn btn-primary"
                  onClick={toggleModal}
                >
                  <MDBIcon fas icon="file-import" className="d-inline me-1" />Import
                </button>
              }
            </div>
          </div>
          <div className="tableContainer">
            <MDBDatatable className="sno staffDatatable" fixedHeader maxHeight="88vh" data={basicData} />
          </div>
        </div>}

      {isOpen && (
        <Popup
          title="Add Staff"
          ptype="modal-lg"
          content={
            <>
              <div>
                <CreateStaff
                  id={null}
                  backallback={togglePopup}
                  submit="0"
                  sId={sId}
                  errorLimit={errorLimit}
                  addandSave={addandSave}
                  userData={userData}
                  onbacktoStaff={onbacktoStaff}
                />
              </div>
            </>
          }
          handleClose={togglePopup}
        />
      )}
      {openDetailsPop && (
        <Popup
          title="Staff Information"
          ptype="modal-lg"
          content={
            <>
              <div className="popupHeight">
                <SattendanceList
                  id={sId}
                  data={selData}
                  oncheckin={checkinUser}
                  onclose={closeDetails}
                  backallback={togglePopup}
                  submit="0"
                />
              </div>
            </>
          }
          handleClose={closeDetails}
        />
      )}
      <MDBAlert
        color='danger'
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={Error2 != ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert>

      <MDBAlert
        color="success"
        autohide
        position='top-center'
        delay={4000}
        appendToBody
        open={Alerttxt != ""}
        onClose={() => setAlerttxt("")}
      >
        {Alerttxt}
      </MDBAlert>

      <ImportExcelModal
        isOpen={importPopUp}
        toggleModalClose={popUpClose}
        onDownloadSample={handleStaffDownload}
        onImportFile={importStaffSheet}
        errorMessage={errorMessage}

      />




      {importError && (
        <MDBToast
          color="danger"
          defaultOpen
          autohide
          position="top-center"
          appendToBody
          width={400}
          delay={5000}
          headerContent={
            <>
              <strong className="me-auto"><h5>Importing Failed!</h5></strong>
            </>
          }
          bodyContent={importError}
        />
      )}
    </>
  );
};

export default Staff;